const applicationSurveyWithAnswer = {
    "sections": [
        {
            "subject": "場區環境及建築",
            "description": "說明廠區環境及建築的污染防治措施．",
            "questions": [{
                "description": "廠區外圍是否有污染源",
                "type": "scq",
                "options": ["是", "否"],
                "answer":"是",
                "questions": [{
                    "condition": "是",
                    "description": "請說明廠區外圍的污染源為何？",
                    "type": "mcq",
                    "options": ["工廠廢氣、廢水", "垃圾堆積場", "農田、農藥", "禽畜養殖場", {"value": "其他", "elaboration": "請詳述污染源:required"}],
                    "answer":["工廠廢氣、廢水","禽畜養殖場" ],
                }, {
                    "condition": "是",
                    "description": "請說明如何防範廠區及產品受到污染",
                    "type": "oeq",
                    "answer":"工廠產生的廢棄物及廢水，或石化業及廢五金燃燒產生的排煙及落塵等問題，均可能造成土壤不同程度的污染，其中含重金屬的工廠廢水隨著灌溉水流進農地"
                }]
            }, {
                "description": "廠房建築為?",
                "type": "scq",
                "options": ["水泥磚造", "木材", "鐵皮", {"value": "其他", "elaboration": ":required"}],
                "answer":{"value": "其他", "elaboration":"新式大樓"}
            }, {
                "description": "凡清潔度要求不同之作業場所是否加以有效區隔與管理，以避免污染？",
                "type": "scq",
                "options": ["是", {"value": "否", "elaboration": ":required"}],
                "answer":"是"
            }, {
                "description": "蒸氣、水、電及空調等配管有無暴露食品上方？",
                "type": "scq",
                "options": ["是", "否"],
                "answer":"是",
                "questions": [{
                    "condition": "是",
                    "description": "蒸氣、水、電及空調等配管暴露於食品上方，是否保持乾淨？",
                    "type": "scq",
                    "options": ["是", "否"],
                    "answer":"是"
                }]
            }
            ]
        }, {
            "subject": "供水系統",
            "description": "說明供水系統的來源與用水處理．",
            "questions": [{
                "description": "製程用水(包含與食品直接接觸及清洗食品設備、用具之用水及冰塊)之水源為何?",
                "type": "mcq",
                "options": [{"value": "不適用", "elaboration": "required"}, "自來水", "山泉水", "地下水", {"value": "其他", "elaboration": "請說明::required"}],
                "answer":["自來水"],
                "questions": [{
                    "condition": "(不適用|山泉水|地下水|其他)",
                    "description": "如非使用自來水時，每年有無依規定辦理水質檢驗(每年檢驗微生物-總菌落數、大腸桿菌群；每兩年檢驗重金屬-汞、砷、鉛、鎘、鉻、硒)，採樣及檢測方法須為環保署認可之檢驗機構執行",
                    "type": "scq",
                    "options": [{
                        "value": "是(初次申請請提供水質檢驗報告；第二年起請備歷年檢驗報告供現場查驗時核對)",
                        "elaboration": ":file,required"
                    }, {
                        "value": "不適用：需再填寫說明",
                        "elaboration": "請說明::required"
                    }]
                }, {
                    "condition": "(地下水)",
                    "description": "使用地下水源者，其水源與污染源(如：化糞池、廢棄物堆積場…等)距離15公尺以上？",
                    "type": "scq",
                    "options": ["是", {"value":"否：需再填寫說明", "elaboration":"請說明:required"}, "不適用"]
                }]
            }, {
                "description": "製程用水(包含與食品直接接觸及清洗食品設備、用具之用水及冰塊)之水源經何種處理？",
                "type": "mcq",
                "options": ["無", "加氯消毒", "UV燈", "逆滲透", "濾心過濾", {"value": "其他", "elaboration": ":required"}],
                "answer":["UV燈", "逆滲透"]
            }, {
                "description": "非製程用水(雜用水)水源為何？",
                "type": "mcq",
                "options": ["自來水", "山泉水", "地下水", {"value": "其他", "elaboration": "請說明:required"}],
                "answer":["山泉水", "地下水"]
            }, {
                "description": "蓄水池（塔、槽）定期清洗頻率？",
                "type": "scq",
                "options": [
                    {"value": "不適用：需再填寫說明", "elaboration": "請說明:required"},
                    {"value": "年：需說明一年幾次", "elaboration": "一年幾次:required,number"}
                ],
                "answer":{"value":"不適用", "elaboration": "因為,,,,所以"}
            }
            ]
        }, {
            "subject": "衛生管理",
            "description": "說明廠區的衛生管理．",
            "questions": [{
                "description": "請列出廠區內潛藏的病媒",
                "type": "mcq",
                "options": ["無" ,"貓犬", "老鼠", "蠅", "蚊","蟑螂","蜘蛛", "螞蟻", {"value": "其他", "elaboration": "required"}],
                "answer":["無"]
            }, {
                "description": "請勾選出你所採用的病媒防治措施",
                "type": "mcq",
                "options": ["每日清掃/洗環境", "定期清除廢棄物", "清除病媒居住空間", "修補洞口、縫隙", "裝設紗窗、門簾、塑膠簾", "裝設捕蟲燈", "使用黏板(如：黏鼠板)", "器械陷阱(如：捕鼠籠)", "噴灑殺菌劑", "使用環境用藥", {"value": "其他", "elaboration": "required"}],
                "answer":["每日清掃/洗環境", "清除病媒居住空間", "使用黏板(如：黏鼠板)"]

            }, {
                "description": "是否有排水系統",
                "type": "scq",
                "options": ["是", "否"],
                "answer":"是",
                "questions": [{
                    "condition": "是",
                    "description": "請說明排水系統防止病媒侵入之設施？",
                    "type": "mcq",
                    "options": ["水封式(U式)", "網式", "沖孔式", {"value": "其他", "elaboration": "required"}],
                    "answer":["水封式(U式)", "網式", "沖孔式"]
                }, {
                    "condition": "是",
                    "description": "排水系統是否完整暢通、無異味？",
                    "type": "scq",
                    "options": ["是", "否"],
                    "answer":"否"
                }]
            }, {
                "description": "食品用洗潔劑用於食品接觸面，使用後不再經清水沖洗，或用於清洗食品",
                "type": "scq",
                "options": ["不適用，皆未使用洗潔劑", "否，使用後會經清水沖洗，且未使用於清洗食品","是"],
                "answer":"是",
                "questions": [{
                    "condition": "是",
                    "description": "承上題請填寫使用之食品用洗潔劑資訊",
                    "type": "oeq",
                    "format": {
                        "multiple": true,
                        "fields": ["洗潔劑品名", "主要消毒成分", "用途"]
                    },
                    "answer":[
                        {"洗潔劑品名":"加倍潔","主要消毒成分":"有效殺菌方式進行處理","用途":"導致細菌或是病毒的死亡"},
                        {"洗潔劑品名":"次氯酸水","主要消毒成分":"安全與有效","用途":"能使微生物的蛋白質變質，有效殺滅細菌、真菌及病毒"}
                    ]
                }]
            }]
        }, {
            "subject": "人員管理",
            "description": "說明廠區人員的健康管理．",
            "questions": [{
                "description": "每年是否辦理健康檢查（檢查項目需包含A型肝炎、手部皮膚病、出疹、膿瘡、外傷、結核病、傷寒或其他可能造成食品污染之疾病）？",
                "type": "scq",
                "options": ["是", {"value": "否", "elaboration": "required"}],
                "answer":"是"
            }, {
                "description": "與食品接觸人員穿戴配備",
                "type": "mcq",
                "options": ["工作服", "工作帽或髮網", "口罩", "不透水手套", {"value": "其他", "elaboration": "請說明:required"}],
                "answer":{"value":["工作服", "其他"],"elaboration":"天然製作，高效殺菌！多用途電解消毒液製造機，防疫精選小物，輕輕一按，想噴哪裡就噴哪裡，給您一個安全健康的空間" }
            }]
        }, {
            "subject": "原料",
            "description": "說明原料的檢核程序．",
            "questions": [{
                "description": "請說明原料進貨時之驗收項目",
                "type": "mcq",
                "options": ["包裝完整性/清潔度", "原料外觀/色澤", "原料標示", "原料有效日期", "原料溫度", "原料氣味", "規格表", "證書/證明文件", "供應商提供檢驗報告", {"value": "自主檢驗：需再填寫說明", "elaboration": "required"}, {"value": "其他", "elaboration": "required"}],
                "answer":["包裝完整性/清潔度", "原料外觀/色澤","原料氣味", "規格表"]
            }, {
                "description": "食品添加物是否專櫃、專人、專冊登錄管理，並建立重複檢核程序？",
                "type": "scq",
                "options": ["不適用(全場未使用食品添加物)", "是", {"value": "否：需再填寫說明", "elaboration": "請說明:required"}],
                "answer":"是"
            }]
        }
    ]
}

export default applicationSurveyWithAnswer;